'use client';

import { DeclineFilledIcon, SuccessIcon } from '@ui/icons/BusinessIcons';
import * as React from 'react';
import { toast as sonnerToast } from 'sonner';

// Type definitions for compatibility with existing usage
// ToastProps is exported from './toast' to avoid conflicts
interface ToastCompatProps {
  title?: string;
  description?: string;
  variant?: 'default' | 'destructive';
  duration?: number;
  action?: React.ReactElement;
}

// ToastActionElement is exported from './toast' to avoid conflicts

// Compatibility type for toaster
interface ToastItem {
  id: string;
  title?: string;
  description?: string;
  action?: React.ReactElement;
  variant?: 'default' | 'destructive';
  duration?: number;
}

// Updated toast function that uses Sonner with icons
export function toast({
  title,
  description,
  variant,
  duration,
  action,
}: ToastCompatProps) {
  const message = title || description || '';
  const options = {
    description: title && description ? description : undefined,
    duration: duration || 4000,
    action: action,
  };

  switch (variant) {
    case 'destructive':
      return sonnerToast.error(message, {
        ...options,
        icon: React.createElement(DeclineFilledIcon, { className: 'h-5 w-5' }),
      });
    default:
      return sonnerToast.success(message, {
        ...options,
        icon: React.createElement(SuccessIcon, { className: 'h-5 w-5' }),
      });
  }
}

// Hook for compatibility with existing usage
export function useToast() {
  return {
    toast,
    dismiss: (toastId?: string) => {
      if (toastId) {
        sonnerToast.dismiss(toastId);
      } else {
        sonnerToast.dismiss();
      }
    },
    // Backward compatibility - empty array since Sonner manages its own toasts
    toasts: [] as ToastItem[],
  };
}

// Types are already exported above
